import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Button } from './atoms/Button'
import { NavState } from '../types/models'

export interface ButtonListMenuProps {
  buttons: Record<string, string>
  states?: Record<string, NavState>
  url?: string
}

export function ButtonListMenu(props: ButtonListMenuProps) {
  const { buttons, states, url } = props
  const button = { color: 'white', backgroundColor: 'secondary.main' }
  const box = { mt: 2 }
  const navigate = useNavigate()

  return <Box sx={{ mt: 3, textAlign: 'center' }}>
    {
      Object.entries(buttons).map(([k, v]) =>
        <Box key={v} sx={box}>
          <Button
            sx={button}
            onClick={() => navigate(url ? url.replace(':id', v) : v, states ? { state: states[k] } : undefined)}
          >
            {k}
          </Button>
        </Box>
      )
    }
  </Box>
}
